export * from './actividad-filter.component';


// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/actividad/actividad-filter/index.ts